export default {
    // 意大利语
    LOCALE_HTML: {
        'msg.language': '意大利语',
        'msg.title': 'Titolo',
        'msg.type': 'Categoria della Domande',
        'msg.des': 'Descrizione della Domanda',
        'msg.phone': 'Numero di Telefono',
        'msg.regionCode': 'Prefisso',
        'msg.email': 'Email',
        'msg.choose': 'Seleziona una Categoria',
        'msg.detail': 'Dettagli del Messaggio',
        'msg.back': 'Indietro',
        'your.msg': 'Lascia il tuo Messaggio',
        'msg.record': 'Registrazione del Messaggio',
        'msg.success': 'Messaggio successo',
        'to.record': 'Va alla Registrazione del Messaggio',
        completed: 'Completa',
        submit: 'Invia',
        'success.desc': 'Il tuo messaggio è stato inviato con successo, grazie',
        'msg.form.input': 'Scrivi, per favore',
        'msg.reply': 'Rispondi',
        'comment.suc': 'Grazie per la tua recensione',
        'comment.fail': 'Presentazione fallita',
        'comment.placeholder':
            'Vi inviamo a dare i suggerimenti sui nostri servizi',
        'reply.suc': 'Inviato con successo',
        'reply.fail': 'Inserisce la tua risposta',
        'reply.placeholder': 'Inserisci la tua risposta',
        'msg.more': 'Per Vedere di Più',
        'msg.collapse': 'Raccoglie',
        'msg.myservice': 'La mia Valutazione del Servizio',
        'msg.evaluate': 'Valutazione del Servizio',
        'msg.evaluateTitle': 'Valutazione del Servizio',
        'msg.score': 'Punteggio',
        'msg.remark': 'Commenti',
        'msg.status.created': 'Creato',
        'msg.status.pending': 'In Attesa di',
        'msg.status.processing': 'Accettato',
        'msg.status.solved': 'Completato',
        'msg.service.reply': 'Risposta del Servizi Cliente',
        'msg.my.reply': 'La mia Risposta',
        'msg.toast.des': 'La descrizione del problema è vuota',
        'msg.toast.type': 'La categoria del problema è vuota',
        'msg.toast.title': 'Il titolo è vuoto',
        'msg.toast.none': 'Non può essere vuoto',
        'msg.toast.noAnnex': 'Si prega di caricare un allegato',
        'msg.toast.noEmail': "L'email non può essere vuoto",
        'msg.toast.noTel': 'Il numero di telefono non può essere vuoto',
        'msg.toast.noRegionCode': 'Il prefisso non può essere vuoto',
        'msg.toast.noZone': 'Seleziona un fuso orario',
        'msg.toast.noDateTime': "Seleziona la data e l'ora",
        'msg.toast.email': 'Si prega di inserire indirizzo email corretto',
        'msg.toast.tel': 'Si prega di inserire il numero di telefono corretto',
        'msg.toast.regionCode': 'Seleziona il prefisso',
        'msg.toast.num': 'Si prega di inserire numero valido',
        'msg.toast.annex': 'Si prega di caricare gli allegati',
        'msg.toast.char': 'Si prega di inserire i caratteri validi',
        'msg.list.none': 'Nessun dato',
        'msg.form.choose': 'Seleziona',
        'msg.form.chooseZone': 'Seleziona il fuso orario',
        'msg.form.chooseTime': "Seleziona l'ora",
        'msg.form.chooseDate': 'Seleziona la data',
        'msg.form.sure': 'OK',
        'msg.form.search': 'Cerca',
        'msg.form.uploadError': 'Formato sbagliato',
        'msg.form.uploadXss':
            'Caricamento non riuscito, il contenuto del file contiene uno script illegale',
        'msg.update.time': 'Aggiornato il',
        'msg.replace.images': 'Immagine',

        MSG016: 'Risolto',
        MSG017: 'Irrisolto',
        MSG019: 'Invia',
        MSG072: `L'etichetta di valutazione non può essere vuota!`,
        MSG073: 'La lingua di valutazione non può essere vuota! ',
        MSG074: 'Etichetta:',
        MSG075: 'È Stato Risolto :',
        MSG076: 'Seleziona se il problema è stato risolto',
        MSG015: 'Questo ticket ha risolto il tuo problema?',

        'file.size.limit': 'La dimensione del file non può superare 50 MB',
        'detail.file.limit':
            'Al massimo 15, la domensione non può superare 50M',
        'form.question.des.tip':
            'Per favore inserisci la descrizione del problema',
        'form.title.tip': 'Per favore inserisci un titolo',
        'form.class.tip': 'Seleziona la categoria della tua domanda',
        'upload.file': 'Carica gli Allegati',
        'file.count.limit': 'Puoi caricare solo fino a 15 allegati',
        'select.search.placeholder': 'Ricerca per la parola chiave',
        'msg.form.sizeError1': 'Si prega di caricare gli allegati meno di 5M',
        'msg.form.sizeError2': 'Si prega di caricare gli allegati meno di 50M',
        'msg.form.submit': 'Presentando…',
        'msg.form.upload': 'Caricando…',
        'msg.email.tip1': 'Il tuo messaggio non è stato trovato',
        'msg.email.tip2':
            'Se hai già lasciato un messaggio precedentemente, potresti controllare via email',
        'msg.email.tip3': "Inizia la Verifica dell'Email",
        'msg.email.noData': 'Nessun dato nel account corrente',
        'email.verify.tip':
            'Si prega di inserire indirizzo email che è stato usato per lasciare un messaggio',
        'email.input.placeholder': 'Si prega di inserire indirizzo email',
        'email.submit': 'Invia Email',
        'email.rules.error': 'Si prega di inserire indirizzo email valido',
        'email.code.tip':
            "L'email è stato inviato, inserisci il codice di verifica che hai ricevuto",
        'email.code.placeholder': 'Inserisci il codice di verifica',
        'email.code.submit': 'Vedere Ora',
        'email.notFind.customer':
            'Informazione del cliente non è stato trovato',
        'email.code.wrong':
            'Il codice di verifica non è corretto, per favore inseriscilo di nuovo',
        'email.code.expired':
            "Il codice di verifca è scaduto, si prega di verificare un'altra volta",
        'email.code': 'Il Codice di Verifica',
        'email.send.frequently':
            "L'operazione è troppo frequente, riprova più tardi",
        'comment.fail.400133': 'Questo biglietto è stato valutato',
        'not.get.user.info': 'Impossibile ottenere le informazioni',
        'user.verify.tip':
            "È necessario verificare prima di poter visualizzare il contenuto dell'elenco dei messaggi",
        'verify.type.email': 'Verifica Email',
        'verify.text': 'Validare',
        'cancel.text': 'Annulla',
        'get.verify.code': 'Ottenere il Codice di Verifica',
        'reGet.verify.code': 'Reacquire',
        'verify.by.email.tip':
            "Il codice di verifica sarà inviato via email all'indirizzo email che hai inserito",
        'verify.type.phone': 'Verifica SMS',
        'phone.placeholder': 'Inserisci il tuo numero di telefono',
        'verify.by.phone.tip':
            'Il codice di verifica verrà inviato via SMS al numero di telefono che hai inserito',
        'phone.error': 'Inserisci il numero di telefono corretto',
        'phone.errorCode400150': 'Invio frequente di codici di verifica',
        'phone.errorCode400233': 'Il modello SMS non può essere vuoto',
        'phone.errorCode400234':
            'Bilancio insufficiente degli SMS di marketing',
        'phone.errorCode400235': 'Saldo SMS di notifica insufficiente',
        'phone.errorCode400247':
            'Errore di configurazione SMS del plugin ordine di lavoro',
        'phone.errorCode4400248': 'Impossibile ottenere il modello SMS',
        'phone.errorCode400249':
            'Questo numero non è il numero di telefono di un utente esistente',
        'phone.errorCode400250':
            'Il codice di verifica è scaduto, si prega di ottenerlo di nuovo',
        'msg.you.reply': 'Ti ha Risposto',
        'msg.no.reply':'nessuna risposta',
    },
    LOCALE_REQUEST: {
        400016: "Il recupero delle informazioni sull'ordine di lavoro è scaduto, aggiorna!"
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'Eliminare',
                cancel: 'Annulla',
                confirm: 'OK',
                inert: 'Inserire',
                width: 'Larghezza',
                height: 'Alto'
            },
            controls: {
                clear: 'Contenuto Chiaro',
                undo: 'Revocare',
                redo: 'Rifare',
                fontSize: 'Carattere',
                lineHeight: 'Altezza Riga',
                letterSpacing: 'Spaziatura',
                textIndent: 'ParagrafoIndent',
                increaseIndent: "AumentaIndent",
                decreaseIndent: "DiminuisciIndent",
                border: 'Telaio',
                color: 'Colore',
                textColor: 'Colore del Testo',
                backgroundColor: 'Colore di Sfondo',
                tempColors: 'Colore Temporaneo',
                bold: 'Grassetto',
                italic: 'Corsivo',
                underline: 'Sottolineare',
                strikeThrough: 'Barrato',
                fontFamily: 'Font',
                textAlign: 'Allineamento del Testo',
                alignLeft: 'Sinistra',
                alignCenter: 'Al Centro',
                alignRight: 'Giusto',
                alignJustify: 'Entrambe le Estremità',
                floatLeft: 'Galleggiante a Sinistra',
                floatRight: 'Galleggia a Destra',
                superScript: 'Apice',
                subScript: 'Pedice',
                removeStyles: 'Stile Chiaro',
                headings: 'Titolo',
                header: 'Titolo',
                normal: 'Convenzionale',
                orderedList: 'Lista Ordinata',
                unorderedList: 'Lista Non Ordinata',
                blockQuote: 'Citazione',
                code: 'Il codice',
                link: 'Collegamento',
                unlink: 'Collegamento Chiaro',
                hr: 'Linea Orizzontale',
                media: 'Media',
                mediaLibirary: 'Libreria Multimediale',
                emoji: 'Piccola Espressione',
                fullscreen: 'Intero Schermo',
                exitFullscreen: 'Esci dalla modalità schermo intero'
            },
            linkEditor: {
                textInputPlaceHolder: 'Inserisci il testo del link',
                linkInputPlaceHolder: "Inserisci l'indirizzo del link",
                inputWithEnterPlaceHolder:
                    "Immettere l'indirizzo del collegamento e premere Invio",
                openInNewWindow: 'Apri in una nuova finestra',
                removeLink: 'Rimuovere collegamento'
            },
            audioPlayer: {
                title: 'Riprodurre file audio'
            },
            videoPlayer: {
                title: 'Riprodurre file video',
                embedTitle: 'Supporti incorporati'
            },
            media: {
                image: 'Immagine',
                video: 'video',
                audio: 'Audio',
                embed: 'Supporti incorporati'
            }
        },
        finder: {
            remove: 'Eliminare',
            cancel: 'Annulla',
            confirm: 'OK',
            insert: "Inserire l'Elemento Selezionato",
            width: 'Larghezza',
            height: 'Alto',
            image: 'Immagine',
            video: 'Video',
            audio: 'Audio',
            embed: 'Supporti incorporati',
            caption: 'Libreria Multimediale',
            dragTip: 'Fare Clic O Trascinare il File Qui',
            dropTip: 'Rilascia per Caricare',
            selectAll: 'Seleziona Tutto',
            deselect: 'Annullare la Selezione',
            removeSelected: "Eliminare l'Elemento Selezionato",
            externalInputPlaceHolder: 'Nome Risorsa|Indirizzo Risorsa',
            externalInputTip: `Utilizzare "|" per separare il nome e l'indirizzo della risorsa`,
            addLocalFile: 'Aggiungi Risorse Locali',
            addExternalSource: 'Aggiungi Risorsa Web',
            unnamedItem: 'Progetto Senza Titolo',
            confirmInsert: "Inserisci l'Elemento Selezionato"
        }
    }
}
